import { modes } from "../modes";
import { permissions } from "../permissions/permissions";

export const pricingPermissionProfile = {
    MANAGE_PPRICING: {
        [modes.EDIT_PERMISSION]: [permissions.PRICING.MANAGE_PPRICING],
    }
}